import {
  Avatar,
  Typography,
  IconButton,
  useTheme,
  useMediaQuery,
  Box,
  Fade,
} from '@mui/material'
import { ArrowBack } from '@mui/icons-material'
import { useNavigate } from 'react-router-dom'
import { useChatStore } from '@client/store'

export function ChatHeader() {
  const theme = useTheme()
  const isMdScreen = useMediaQuery(theme.breakpoints.up('lg'))
  const navigate = useNavigate()
  const { character } = useChatStore()

  const handleArrowLeftClick = () => {
    navigate('/#')
  }

  return (
    <Fade in timeout={500}>
      <Box
        sx={{
          width: '100%',
          maxWidth: 960,
          mx: 'auto',
          px: 2,
          pt: 1,
          pb: 1.5,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          position: 'relative',
          flexShrink: 0,
        }}
      >
        {!isMdScreen && (
          <IconButton
            onClick={handleArrowLeftClick}
            sx={{
              position: 'absolute',
              left: 8,
              color: 'grey.400',
              '&:hover': { color: 'white' },
            }}
            aria-label="Go to home"
          >
            <ArrowBack fontSize="small" />
          </IconButton>
        )}

        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: 1.5,
            minWidth: 0,
          }}
        >
          <Avatar
            alt={character?.name || 'Anon'}
            src={character?.profile_image || ''}
            sx={{ width: 40, height: 40 }}
          />

          <Typography
            variant="h6"
            sx={{
              fontSize: '1rem',
              whiteSpace: 'nowrap',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              maxWidth: 220,
            }}
          >
            {character?.name || 'Anon'}
          </Typography>
        </Box>
      </Box>
    </Fade>
  )
}